import styled from '@emotion/styled'
import React from 'react'
import UnderlineInput from './InputField/UnderlineInput'
import TinyLabel from './TinyLabel'










const Label = styled(TinyLabel)({
  fontSize: 12,
  fontWeight: 600
})

const EmailInputField = (props) => {
  const {autoFocus, dirty, error, onChange, onBlur, value} = props
  return (
    React.createElement(React.Fragment, null
      , React.createElement(Label, null, "Email")
      , React.createElement(UnderlineInput, {
        ariaLabel: 'Email',
        autoFocus: autoFocus,
        error: dirty ? (error ) : undefined,
        name: "email",
        onBlur: onBlur,
        onChange: onChange,
        placeholder: "you@company.co",
        type: 'email',
        value: value,}
      )
    )
  )
}

export default EmailInputField
